import { ServiceFetch } from '../service-fetch'

export default class ProductGroupScaleModel extends ServiceFetch {
    getProductGroupScaleBy = (data) => this.authFetch({
        url: 'product-group-scale/getProductGroupScaleBy',
        method: 'POST',
        body: JSON.stringify(data),
    })
}